// Fallback page for the OLD /auth/magic?token=... links that may still be in
// inboxes after the migration to the server-side redirect flow. We post the
// token straight to the API endpoint via a fresh navigation so the browser
// follows the 302 and stores the auth cookie atomically — no React/XHR race.
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useI18n } from "../i18n";
import { Loader2 } from "lucide-react";

export default function MagicVerify() {
    const [params] = useSearchParams();
    const { t } = useI18n();
    const token = params.get("token");

    useEffect(() => {
        if (!token) return;
        const url = `/api/auth/magic/verify?token=${encodeURIComponent(token)}`;
        // Hard navigation — server handles cookie + redirect.
        window.location.replace(url);
    }, [token]);

    return (
        <div className="max-w-md mx-auto px-4 pt-20 pb-20 text-center" data-testid="magic-verify-page">
            <Loader2 className="h-8 w-8 animate-spin text-[var(--accent-hex)] mx-auto mb-4" />
            <p className="text-[var(--text-secondary)]" data-testid="magic-verifying">{t("auth.magic.verifying")}</p>
        </div>
    );
}
